/* BVF v6 behaviour: hero drawing sheets, dispatch board, insert-code decoder, product
   rail arrows, WhatsApp quote link, phone tab bar. Loaded (defer) by snippets/bvf-mega-menu.liquid.
   Plain JS, no dependencies. Everything stops when prefers-reduced-motion is set or the
   tab is hidden, and pauses while the pointer is over it. */
(function () {
  if (window.bvfHome) return;
  window.bvfHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ticker(el, ms, fn) {
    if (reduce || !ms) return { stop: function () {} };
    var hover = false, stopped = false, id;
    el.addEventListener('mouseenter', function () { hover = true; });
    el.addEventListener('mouseleave', function () { hover = false; });
    el.addEventListener('focusin', function () { hover = true; });
    el.addEventListener('focusout', function () { hover = false; });
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(el);
    }
    id = setInterval(function () { if (!stopped && !hover && visible && !document.hidden) fn(); }, ms);
    return { stop: function () { stopped = true; clearInterval(id); } };
  }

  function tabs(list, onPick) {
    var btns = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(i, focus) {
      btns.forEach(function (b, j) {
        b.setAttribute('aria-selected', j === i ? 'true' : 'false');
        b.tabIndex = j === i ? 0 : -1;
      });
      if (focus) btns[i].focus();
      onPick(i, btns[i]);
    }
    list.addEventListener('keydown', function (e) {
      var i = btns.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select((i + 1) % btns.length, true); return 'user'; }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); select((i - 1 + btns.length) % btns.length, true); }
    });
    return { btns: btns, select: select };
  }

  /* hero sheets */
  document.querySelectorAll('[data-bvf-sheets]').forEach(function (root) {
    var list = root.querySelector('.bvf-hero__tabs');
    var sheets = root.querySelectorAll('.bvf-sheet');
    var mcard = root.querySelector('[data-bvf-mcard]');
    if (!list || sheets.length < 2) return;
    var cur = 0, t;
    var tb = tabs(list, function (i) {
      cur = i;
      sheets.forEach(function (s, j) {
        if (j === i) {
          s.classList.remove('is-active'); void s.offsetWidth; s.classList.add('is-active');
        } else s.classList.remove('is-active');
      });
      if (mcard) {
        var s = sheets[i];
        mcard.href = s.dataset.url;
        ['tag', 'title', 'price', 'incl'].forEach(function (k) {
          var f = mcard.querySelector('[data-f="' + k + '"]');
          if (f) f.textContent = s.dataset[k] || '';
        });
      }
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[role="tab"]');
      if (!b) return;
      t.stop();
      tb.select(tb.btns.indexOf(b));
    });
    list.addEventListener('keydown', function () { t.stop(); });
    t = ticker(root, parseInt(root.dataset.interval, 10) || 5000, function () { tb.select((cur + 1) % sheets.length); });
  });

  /* dispatch board: rotate rows, newest flips in at the top */
  document.querySelectorAll('[data-bvf-board]').forEach(function (board) {
    var wrap = board.querySelector('[data-bvf-rows]');
    var rows = Array.prototype.slice.call(wrap.children);
    var show = parseInt(board.dataset.show, 10) || 6;
    if (rows.length < 2) return;
    var off = 0;
    function render() {
      for (var i = 0; i < rows.length; i++) {
        var r = rows[(off + i) % rows.length];
        r.classList.remove('is-new');
        r.hidden = i >= show;
        wrap.appendChild(r);
        if (i === 0) { void r.offsetWidth; r.classList.add('is-new'); }
      }
    }
    ticker(board, parseInt(board.dataset.ms, 10) || 3000, function () { off = (off - 1 + rows.length) % rows.length; render(); });
  });

  /* insert-code decoder */
  document.querySelectorAll('[data-bvf-decoder]').forEach(function (root) {
    var list = root.querySelector('[role="tablist"]');
    var out = root.querySelector('.bvf-decoder__out');
    if (!list || !out) return;
    var cur = 0, t;
    var tb = tabs(list, function (i, b) {
      cur = i;
      out.querySelector('[data-o="pos"]').textContent = 'Position ' + b.dataset.pos + ' · ' + b.dataset.t;
      out.querySelector('[data-o="d"]').textContent = b.dataset.d;
      out.querySelector('[data-o="x"]').textContent = b.dataset.x;
      out.classList.remove('is-anim'); void out.offsetWidth; out.classList.add('is-anim');
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[role="tab"]');
      if (!b) return;
      t.stop();
      tb.select(tb.btns.indexOf(b));
    });
    list.addEventListener('keydown', function () { t.stop(); });
    t = ticker(root, parseInt(root.dataset.ms, 10) || 3000, function () { tb.select((cur + 1) % tb.btns.length); });
  });

  /* product rail arrows */
  document.querySelectorAll('[data-bvf-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-bvf-track]');
    var prev = rail.querySelector('[data-bvf-prev]');
    var next = rail.querySelector('[data-bvf-next]');
    if (!track || !prev || !next) return;
    function step() { var li = track.querySelector('li'); return li ? li.getBoundingClientRect().width + 16 : 300; }
    function sync() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* quote: WhatsApp button carries the typed list */
  document.querySelectorAll('[data-bvf-wa]').forEach(function (a) {
    var form = a.closest('form');
    var ta = form && form.querySelector('textarea');
    if (!ta) return;
    a.addEventListener('click', function () {
      var text = (ta.value || '').trim();
      a.href = 'https://wa.me/' + a.dataset.bvfWa + '?text=' + encodeURIComponent('Quote request (bvftools.com):\n' + (text || ta.placeholder));
    });
  });

  /* phone tab bar */
  var bar = document.querySelector('[data-bvf-tabbar]');
  if (bar) {
    document.body.classList.add('bvf-has-tabbar');
    document.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches('input:not([type=checkbox]):not([type=radio]):not([type=submit]), textarea, select')) document.body.classList.add('bvf-kb-open');
    });
    document.addEventListener('focusout', function () { document.body.classList.remove('bvf-kb-open'); });
  }

  /* cart page: refresh the GST estimate box after quantity changes (it sits outside Dawn's
     re-rendered .js-contents) */
  var cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter && cartFooter.dataset.id && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetch(window.location.pathname + '?section_id=' + cartFooter.dataset.id)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.bvf-gst-note');
          var old = cartFooter.querySelector('.bvf-gst-note');
          if (fresh && old) old.replaceWith(fresh);
        })
        .catch(function () {});
    });
  }
})();
